
/* ----------------------------------------------------------
FILTRO LOJAS E RESTAURANTES
------------------------------------------------------------- */

// const filterBoxInputText 		= $('#lojas .filtros form input[type="text"]');

// const filterBox 				= $('#lojas .filtros');
// const filterBoxInput 			= $('#lojas .filtros form input:not([type="text"])');
// const filterBoxInputSegmentos 	= $('#lojas .filtros #filterSegmentoForm input');
// const filterBoxInputText 		= $('#lojas .filtros form input[type="text"]');
// const storeList					= $('#lojas #lojasList');
// const storeListItem				= $('#lojas #lojasList li');
// const filterFlags				= $('.listaFiltrosMobile');

// const filterNameFormObj			= $('#filterNameForm');
// const storeListError			= $('#lojas #lojasList .error');

/* DETALHES LOJAS

function detalhesLOjas()
{
	var otherDatails = $('#lojasList li');

	$('a.moreDetails, #lojas #lojasList li div.titulo').on('click',function(e)
	{
		e.preventDefault();

		var parent = $(this).parent('li').toggleClass('opened');
	});
}

/* CRIA E REMOVE FLAGS NA VERSÃO CELULAR PORTRAIT

function removeflags()
{
	filterFlags.find('ul').find('li').each(function()
	{
		var input = filterBox.find('input'+$(this).data('field'));

		$(this).on('click',function()
		{
			input.prop('checked',false);
			$(this).remove();
			arrayFilters('checkbox');
		});
	})
}

function createFlags(filtros)
{

	var html = '';

	for(var i = 0; i < filtros.length; i++)
	{
		var label = filtros[i].title;
		// var label = '';
		// if(filtros[i].data == 'segmento') {
		// 	label = filtros[i].title;
		// } else {
		// 	label = filtros[i].data.replace('-' , ' ' );
		// 	label = label.charAt(0).toUpperCase() + label.slice(1);
		// }

		html += '<li class="noDot" data-field="#'+filtros[i].id+'">';
			html += '<span>'+label+'</span>';
			html += '<i class="icon-cancel"></i>';
		html += '</li>';
	}

	filterFlags.find('ul').html(html);

	removeflags();
}

/* MORE FILTERS

function moreFilters()
{
	$('#lojas .filtros h3.more').on('click',function(e)
	{
		e.preventDefault();

		if( !$(this).hasClass('opened') )
		{
			$(this).addClass('opened');
			$('#lojas .filtros > .colapseFilters').removeClass('opened').addClass('opened');
		}
		else
		{
			$(this).removeClass('opened');
			$('#lojas .filtros > .colapseFilters').removeClass('opened');
		}
	});

	$('#lojas .filtros .filtroSegmento h4').on('click',function(e)
	{
		e.preventDefault();

		if( !$(this).hasClass('opened') )
		{
			$(this).addClass('opened');
			$('#lojas .filtros .filtroSegmento .colapseFilters').removeClass('opened').addClass('opened');
		}
		else
		{
			$(this).removeClass('opened');
			$('#lojas .filtros .filtroSegmento .colapseFilters').removeClass('opened');
		}
	});
}


/* LIMPA STRING DO NOME DA LOJA

function accentsTidy(s)
{
	var r=s.toLowerCase();
	//r = r.replace(new RegExp(/\s/g),"");
	r = r.replace(new RegExp(/[àáâãäå]/g),"a");
	r = r.replace(new RegExp(/æ/g),"ae");
	r = r.replace(new RegExp(/ç/g),"c");
	r = r.replace(new RegExp(/[èéêë]/g),"e");
	r = r.replace(new RegExp(/[ìíîï]/g),"i");
	r = r.replace(new RegExp(/ñ/g),"n");
	r = r.replace(new RegExp(/[òóôõö]/g),"o");
	r = r.replace(new RegExp(/œ/g),"oe");
	r = r.replace(new RegExp(/[ùúûü]/g),"u");
	r = r.replace(new RegExp(/[ýÿ]/g),"y");
	// r = r.replace(new RegExp(/\W/g),"");
	return r;
};

/* EXECUTA FILTROS

function FiltrarPor()
{
	this.nomeLoja = function(value)
	{
		var strNormalized = accentsTidy(value);

		filterBoxInputText.addClass('filtered');
		storeListItem.removeClass('deactived').addClass('visible');

		var strNormalized = accentsTidy(value).toLowerCase();

		storeListItem.each(function()
		{
			var title = accentsTidy( $(this).data('slug') ).toLowerCase();

			if(title.indexOf( strNormalized ) < 0 )
			{
				$(this).removeClass('visible').addClass('deactived');
			}
		});

		var urlPath = window.location.pathname.split('/');
		history.pushState({}, '', './'+urlPath[urlPath.length-1]);

		var totalStoreListVisible = 0;

		storeListItem.each(function()
		{
			if( $(this).hasClass('visible') )
			{
				totalStoreListVisible++;
			}
		});

		if(totalStoreListVisible <= 0)
		{
			storeListError.addClass('visible').html('<p>'+storeListError.data('msg')+'</p>');
		}
		else
		{
			storeListError.removeClass('visible').html('');
		}
	}

	this.atributos = function(filtros)
	{
		storeListError.removeClass('visible').html('');
		storeListItem.removeClass('deactived').addClass('visible');


		var arrayQueryString = [];
		var wasSegmento = 0;

		storeListItem.each(function()
		{
			for(var i = 0; i < filtros.length; i++)
			{
				if(filtros[i].types == 'beneficios') {
					if($(this).data( filtros[i].id ) == false ) {
						$(this).removeClass('visible').addClass('deactived');
					} else if($(this).data( filtros[i].id) == true) {
						arrayQueryString[filtros[i].data ] = true;
					}
				} else if(filtros[i].types == 'segmentos') {
					if($(this).data( filtros[i].data ) != filtros[i].val) {
						$(this).removeClass('visible').addClass('deactived');
					} else if($(this).data( filtros[i].data ) == filtros[i].val) {
						arrayQueryString['segmento'] = $(this).data( filtros[i].data ) ;
					}
				} else if( filtros[i].types != 'segmentos') {
					if($(this).data( filtros[i].data ) == false ) {
						$(this).removeClass('visible').addClass('deactived');
					}
				}
			}
		});

		// Criação da string da query string
		var originQueryString = '';
		Object.entries(arrayQueryString).forEach(function (item, index) {
			var key = item[0];
			var value = item[1];

			if(index == 0 ) {
				originQueryString = originQueryString + key + '=' + value;
			} else {
				originQueryString = originQueryString + '&' + key + '=' + value;
			}
		});

		if(originQueryString) {
			var urlPath = window.location.pathname.split('/');
			history.pushState({}, '', './'+urlPath[urlPath.length-1]+'?'+originQueryString );
		} else {
			var urlPath = window.location.pathname.split('/');
			history.pushState({}, '', './'+urlPath[urlPath.length-1]);
		}

		var totalStoreListVisible = 0;

		storeListItem.each(function()
		{
			if( $(this).hasClass('visible') )
			{
				totalStoreListVisible++;
			}
		});

		if(totalStoreListVisible <= 0)
		{
			storeListError.addClass('visible').html('<p>'+storeListError.data('msg')+'</p>');
		}
	}
}

/*
CRIA ARRAY COM ITENS SELCIONADOS NOS FILTROS
	-> DEPOIS CHAMA FUNÇÃO (ACIMA) QUE EXECUTA FILTRAGEM.
	-> SE FOR MOBILE, TAMBÉM CHAMA FUNÇÃO QUE CRIA A LISTA INDICADORA DOS FILTROS


function arrayFilters(type)
{
	var filtrar = new FiltrarPor();

	if(type == 'checkbox')
	{
		var allFilters = [];

		filterBoxInput.each(function()
		{
			if( $(this).is(':checked') )
			{
				allFilters.push({
				    id		: $(this).attr('id'),
				    data 	: $(this).data().type,
				    types 	: $(this).data().types,
				    val  	: $(this).val(),
				    title	: $(this).attr('title'),
				});

				if( $(window).width() <= 580 )
				{
					createFlags(allFilters);
				}
			}
		});

		filtrar.atributos(allFilters);
	}

	if(type == 'text')
	{
		filterBoxInputText.each(function()
		{
			filtrar.nomeLoja( $(this).val() );
		});
	}
}

/* ATUALIZAR FILTROS

function atualizarFiltrosCheck()
{
	filterBox.find('#filterNameForm').find('input[type="reset"]').trigger('click');
	filterBoxInputText.removeClass('filtered');
	arrayFilters('checkbox');

	filterBoxInputSegmentos.each(function() {
		if( $(this).is(':checked') ) {
			resetSegmentos.removeClass('hide');
			return false;
		}
	});
}

function limparCheckFiltrosSemFiltrar() {

	filterBoxInput.prop('checked',false);
	filterFlags.find('ul').html('');
	storeListItem.removeClass('deactived').addClass('visible');
	storeListError.removeClass('visible').html('');

	resetSegmentos.addClass('hide');
}

function limparCheckFiltros() {
	limparCheckFiltrosSemFiltrar();
	arrayFilters('checkbox');
}

function limparSegmentosFiltrosSemFiltrar() {
	filterBoxInputSegmentos.prop('checked',false);
	filterFlags.find('ul').html('');
	storeListItem.removeClass('deactived').addClass('visible');
	storeListError.removeClass('visible').html('');

	resetSegmentos.addClass('hide');
}

function limparSegmentosFiltros() {
	limparSegmentosFiltrosSemFiltrar();
	arrayFilters('checkbox');
}

/* VERIFICA QUERY STRING

function checkQueryString() {
	if(window.location.href.split('?')[1])
	{
		var query = window.location.href.split('?')[1];

		var params = query.split('&');

		params.forEach(function (item, index) {

			var _params = item.split('=');
			var _param_index = _params[0];
			var _param_valor = _params[1];

			if(_param_valor) {
				switch(_param_index) {
					case 'segmento':
		    			filterBox.find('.filtroSegmento').find('form input[type="radio"]').each(function() {
							if( $(this).val() == decodeURIComponent(_param_valor) ) {

								$(this).prop('checked',true);

								atualizarFiltrosCheck();
							}
						});
					    break;
					default:
						filterBox.find('.filtroBeneficio').find('form input[type="checkbox"]').each(function() {
							if($(this).data("type") == _param_index && _param_valor == 'true') {

								$(this).prop('checked',true);

								atualizarFiltrosCheck();
							}
						});
					    break;
				}

			}
		});

	}

}


/* INICIALIZA FILTROS

var Filtros = function()
{
	if( filterBox )
	{
		/* INPUT TEXT

		filterBoxInputText.keyup(function(e)
		{
			if($(this).val().length >= 2)
			{
				limparCheckFiltrosSemFiltrar();
				arrayFilters('text');
			}

			if($(this).val().length <= 2)
			{
				limparCheckFiltrosSemFiltrar();
			}
	    });

		/* INPUT CHECKBOX

		filterBoxInput.change(function()
		{
			atualizarFiltrosCheck();

			if( $(this).is('[type="radio"]') ) {
				resetSegmentos.removeClass('hide');
			}
			if($(window).width() <= 740) {
				$('#lojas .filtros h3.more').trigger('click');
			}
		});

		/* CRIA FLAGS NO MOBILE e FECHA O MAIS FILTROS

		if( $(window).width() <= 740 )
		{
			filterFlags.html('<ul></ul>');

			moreFilters();
		}

		/* SUBMIT TEXT FIELD

		filterNameFormObj.on('submit',function(e)
		{
			e.preventDefault();

			$('html,body').stop().animate({ scrollTop : $('#lojasList').offset().top - 90},800);
		});

		/* RESET FORM

		$('.resertFilter').on('click',function()
		{
			filterBox.find('#filterNameForm').find('input[type="reset"]').trigger('click');
			filterBoxInputText.removeClass('filtered');

			storeListError.removeClass('visible').html('');
			storeListItem.removeClass('deactived').addClass('visible');
		});

		resetSegmentos.on('click',function()
		{
			limparSegmentosFiltros();
		});

		/* CHECA URL QUERY STRING
		checkQueryString();
	}

	if( $('#lojasList') )
	{
		detalhesLOjas();
	}
}
*/

// esta funcao estava comentada acima serve para o "X" do filtro 

$('.resertFilter').on('click', function() {
    inptText.val(''); 
    
    lojasListaItens.each(function() {
        $(this).addClass('visible').css('display', 'block');
    });
    inptSearch.dispatchEvent(new Event('input'));    
    inptText.focus(); 
});



const lojasListaItens = $('#lojas #lojasList li.itemLoja');

const inptText = $('#lojas .filtros form input[type="search"]');
const inptRadio = $('#lojas .filtros form input[type="radio"]');
const inptCheck = $('#lojas .filtros form input[type="checkbox"]');

// NOVO: Adicionar referência ao filtro de tipos
const inptBeneficios = $('#lojas .filtros form input[data-types="beneficios"]');
const inptSegmentos = $('#lojas .filtros form input[data-types="segmentos"]');
const inptTorres = $('#lojas .filtros form input[data-types="torres"]');
const inptTipos = $('#lojas .filtros form input[data-types="tipos"]'); // NOVO

const resetBeneficios = $('.resertBeneficiosFilter');
const resetSegmentos = $('.resertSegmentosFilter');
const resetTorres = $('.resertTorresFilter');
const resetTipos = $('.resertTipoLojaFilter'); // NOVO

/* ===============================
   EVENTO CENTRAL DOS RÁDIOS
================================ */

inptRadio.on('change', function () {
	const input = $(this);
	const tipo = input.data('types'); // beneficios | segmentos | torres | tipos
	const valor = input.data('type'); // ifood | Academia | torre-x | tipo-name

	const url = new URL(window.location.href);
	url.searchParams.set(tipo, valor);

	window.history.pushState({}, '', url.href);

	applyFiltersFromURL();
});

/* ================================
   RESET DE FILTROS (NOVO)
================================ */

resetBeneficios.on('click', function () {
	const url = new URL(window.location.href);
	url.searchParams.delete('beneficios');

	window.history.replaceState({}, '', url.href);

	inptBeneficios.prop('checked', false);
	resetBeneficios.addClass('hide');

	applyFiltersFromURL();
});

resetSegmentos.on('click', function () {
	const url = new URL(window.location.href);
	url.searchParams.delete('segmentos');

	window.history.replaceState({}, '', url.href);

	inptSegmentos.prop('checked', false);
	resetSegmentos.addClass('hide');

	applyFiltersFromURL();
});

resetTorres.on('click', function () {
	const url = new URL(window.location.href);
	url.searchParams.delete('torres');

	window.history.replaceState({}, '', url.href);

	inptTorres.prop('checked', false);
	resetTorres.addClass('hide');

	applyFiltersFromURL();
});

// NOVO: Reset para tipos
resetTipos.on('click', function () {
	const url = new URL(window.location.href);
	url.searchParams.delete('tipos');

	window.history.replaceState({}, '', url.href);

	inptTipos.prop('checked', false);
	resetTipos.addClass('hide');

	applyFiltersFromURL();
});

/* ================================
   NORMALIZAR STRING
================================ */

function normalizeString(str) {
	return str
		.toLowerCase()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[^a-z0-9\s-]/g, '')
		.trim()
		.replace(/\s+/g, '-')
		.replace(/-+/g, '-');
}

/* ================================
   ATUALIZAR LISTA COM RÁDIOS
================================ */

const listaLojasRadioUpdate = function()
{
	const url = new URL(window.location.href);
    const params = url.searchParams;

	let filtrosAtivos = 0;
	if (params.has('beneficios')) filtrosAtivos++;
	if (params.has('segmentos')) filtrosAtivos++;
	if (params.has('torres')) filtrosAtivos++;
	if (params.has('tipos')) filtrosAtivos++; // NOVO

	if (filtrosAtivos > 0) {
		lojasListaItens.each(function () {
			let t = 0;
			const item = $(this);

			if (params.has('beneficios'))
			{
				const paramBeneficios = params.get('beneficios');
				const dataBeneficios = item.data(paramBeneficios);

				if (dataBeneficios == true)
					t++;
			}

			// Verifica se o parâmetro 'segmentos' existe na URL
			if (params.has('segmentos'))
			{
				const paramSegmentos = params.get('segmentos');
				const dataSegmentos = item.data('segmentos');

				if (dataSegmentos == paramSegmentos)
					t++;
			}

			// Verifica se o parâmetro 'torres' existe na URL
			if (params.has('torres')) {
				const paramTorres = params.get('torres');
				if (item.data('torres') === paramTorres) {
					t++;
				}
			}

			// NOVO: Validação para tipos
			if (params.has('tipos')) {
				const paramTipos = params.get('tipos');
				if (item.data('tipos') === paramTipos) {
					t++;
				}
			}

			if(t == params.size){
				item.css('display', 'block');
				requestAnimationFrame(() => item.addClass('visible'));
				// $(this).addClass('visible');
			}else{
				
				// $(this).removeClass('visible');
				item.removeClass('visible'); 
				item.one('transitionend', function () {
					if (!item.hasClass('visible')) {
						item.css('display', 'none');
					}
				});
			}
		});
	}else{
		lojasListaItens.each(function()
		{
			const item = $(this);
			// $(this).addClass('visible');
			item.css('display', 'block');
			requestAnimationFrame(() => item.addClass('visible'));
		});
	}
};

/* ================================
   APLICAR FILTROS DA URL
================================ */

const applyFiltersFromURL = function () {

	// Reset visual
	inptBeneficios.prop('checked', false);
	inptSegmentos.prop('checked', false);
	inptTorres.prop('checked', false);
	inptTipos.prop('checked', false); // NOVO

	resetBeneficios.addClass('hide');
	resetSegmentos.addClass('hide');
	resetTorres.addClass('hide');
	resetTipos.addClass('hide'); // NOVO

	const url = new URL(window.location.href);
	const params = url.searchParams;

	if (params.has('beneficios')) {
		const beneficio = params.get('beneficios');
		inptBeneficios
			.filter(`[data-type="${beneficio}"]`)
			.prop('checked', true);
		resetBeneficios.removeClass('hide');
	}

	if (params.has('segmentos')) {
		const segmento = params.get('segmentos');
		inptSegmentos
			.filter(`[data-type="${segmento}"]`)
			.prop('checked', true);
		resetSegmentos.removeClass('hide');
	}

	if (params.has('torres')) {
		const torre = params.get('torres');
		inptTorres
			.filter(`[data-type="${torre}"]`)
			.prop('checked', true);
		resetTorres.removeClass('hide');
	}

	// NOVO: Aplicar filtro de tipos
	if (params.has('tipos')) {
		const tipo = params.get('tipos');
		inptTipos
			.filter(`[data-type="${tipo}"]`)
			.prop('checked', true);
		resetTipos.removeClass('hide');
	}

	listaLojasRadioUpdate();
};

/* ================================
   FILTRO DE TEXTO
================================ */

const inptSearch = document.getElementById('inputPesquisaNomeSlug');

const listaLojasTextUpdate = function (value) {
	/* RESETA FILTROS RÁDIO */

	const url = new URL(window.location.href);
	url.search = '';
	window.history.replaceState({}, document.title, url.toString());

	inptRadio.each(function () {
		$(this).prop('checked', false);
	});

	resetBeneficios.addClass('hide');
	resetSegmentos.addClass('hide');
	resetTorres.addClass('hide');
	resetTipos.addClass('hide'); // NOVO

	/* REALIZA FILTRO TEXTO */

	const normalizedValue = normalizeString(value);

	lojasListaItens.each(function () {
		const $item = $(this);
		const dataSlug = normalizeString($item.data('slug'));

		if (dataSlug.includes(normalizedValue)) {
			$item.css('display', 'block');
			requestAnimationFrame(() => $item.addClass('visible'));
		} else {
			$item.removeClass('visible');
			$item.one('transitionend', function () {
				if (!$item.hasClass('visible')) {
					$item.css('display', 'none');
				}
			});
		}
	});
};

const updateURLParameter = function (param, value) {
	const currentURL = window.location.href;
	const url = new URL(currentURL);

	url.searchParams.set(param, value);
	window.history.pushState({ path: url.href }, '', url.href);

	inptText.val('');

	listaLojasRadioUpdate();
};

const textFilter = function () {
	inptText.keyup(function () {
		if ($(this).val().length >= 2)
			listaLojasTextUpdate($(this).val());
		else
			lojasListaItens.each(function () {
				$(this).addClass('visible');
			});
	});

	inptText.on('keydown', function (e) {
		if (e.key === 'Enter' || e.keyCode === 13) {
			e.preventDefault();

			listaLojasTextUpdate($(this).val());

			// FECHA O MODAL NO MOBILE
			if ($(window).width() <= 991) {
				$('#lojas .filtros').removeClass('opened');
				$('body').css({ 'overflow': 'auto' });
			}
		}
	});

	inptSearch.addEventListener('input', function () {
		if (this.value === '') {
			lojasListaItens.each(function () {
				$(this).css('display', 'block');
			});
		}
	});
};

const radioFilter = function () {
	const url = new URL(window.location.href);
	const params = url.searchParams;

	inptRadio.each(function () {
		const types = $(this).data('types');
		const value = $(this).data('type');

		$(this).on('change', function () {
			updateURLParameter(types, value);
		});

		if (types == 'beneficios' && params.has('beneficios'))
			if (params.get('beneficios') == value)
				$(this).prop('checked', true);
			else
				$(this).prop('checked', false);

		if (types == 'segmentos' && params.has('segmentos'))
			if (params.get('segmentos') == value)
				$(this).prop('checked', true);
			else
				$(this).prop('checked', false);

		if (types == 'torres' && params.has('torres'))
			if (params.get('torres') == value)
				$(this).prop('checked', true);
			else
				$(this).prop('checked', false);

		// NOVO: Validar filtro de tipos
		if (types == 'tipos' && params.has('tipos'))
			if (params.get('tipos') == value)
				$(this).prop('checked', true);
			else
				$(this).prop('checked', false);
	});
};

const mobileModalFilters = function () {
	const body = $('body');
	const modalFiltros = $('#lojas .filtros');
	const buttonOpenModal = $('#lojas .CtaFiltrosMobile button');
	const buttonCloseModal = modalFiltros.find('button.CloseMenuFiltrosMobile');

	buttonOpenModal.click(function () {
		modalFiltros.addClass('opened');
		body.css({ 'overflow': 'hidden' });
	});

	buttonCloseModal.on('click', function () {
		modalFiltros.removeClass('opened');
		body.css({ 'overflow': 'auto' });
	});
};

// RESET DO FILTRO DE NOME
$('.resertFilter').on('click', function () {
	inptText.val('');

	lojasListaItens.each(function () {
		$(this).addClass('visible').css('display', 'block');
	});
	inptSearch.dispatchEvent(new Event('input'));
	inptText.focus();
});

/* INICIANDO CONTROLE DOS FILTROS */

const initFiltrosLojas = function () {
	if ($('main#pageInternas.lojas').length > 0) {
		/* CARREGA LISTA FILTRADA O NÃO INICIALMENTE */
		applyFiltersFromURL();

		/* EVENTO DO FILTRO TEXTUAL */
		textFilter();

		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('inputPesquisaNomeSlug')) {
			const valorPesquisa = urlParams.get('inputPesquisaNomeSlug');
			inptText.val(valorPesquisa);
			listaLojasTextUpdate(valorPesquisa);
		}

		/* EVENTO DOS FILTROS RADIO */
		radioFilter();

		/* EVENTO DOS FILTROS MOBILE */
		if ($(window).width() <= 991)
			mobileModalFilters();

		$(window).resize(function () {
			if ($(window).width() <= 991)
				mobileModalFilters();
		});
	}
};

// Inicializar
$(document).ready(function () {
	initFiltrosLojas();
});